/**
 * @typedef {{cd: string, text: string, type: number}} University
 */

/**
 * @param {string} text
 * @returns {Promise<Array<University>|[]>}
 */
export const getUniversityList = async text => {
  const token = /** @type {HTMLInputElement|undefined} */ (document.getElementsByName('_token')[0])?.value ?? ''
  const url = /** @type {HTMLInputElement|undefined} */ (document.getElementById('url_suggest_university'))?.value ?? ''
  const query = new URLSearchParams({ text: text })
  const response = await fetch(url + '?' + query, {
    method: 'GET',
    headers: {
      'X-CSRF-TOKEN': token,
    },
  })
  const responseData = await response.json()
  if (responseData.result === 'success') {
    if (Object.keys(responseData.validation).length > 0) {
      return []
    }
  } else {
    alert('エラーが発生しました')
    return []
  }

  return responseData.data
}
